import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserComplete } from '../../models/account/user-complete.model';

export const UserActions = createActionGroup({
    source: 'User',
    events: {
        'Load User': props<{ refresh:boolean | undefined}>(),
        'Logout User': emptyProps
    }
})

export const UserApiActions = createActionGroup({
    source: 'User API',
    events: {
        'Retrieve User': props<UserComplete>()
    }
})